import { AxiosInstance } from 'axios';
import { OutsourcingRepository } from '@/model/repository/manager/outsourcing/OutsourcingRepository';
import axios from 'axios';

export default (Repository: AxiosInstance | null) =>
  (resource: string): OutsourcingRepository => ({
    index() {
      if (Repository) {
        return Repository.get(resource, {});
      } else {
        const instance = axios.create({ withCredentials: true });
        return instance.get(resource, {});
      }
    },
  });
